import { useTranslation } from 'react-i18next';

export default function Loading() {
  const { t } = useTranslation();
  return (
    <div className="min-h-dvh flex items-center justify-center bg-ivory">
      <div className="text-center space-y-4 animate-pulse">
        <div className="w-8 h-8 mx-auto border border-charcoal/20 rounded-full" />
        <p className="text-xs tracking-widest-xl uppercase text-charcoal/40 font-sans">{t('common.loading')}</p>
      </div>
    </div>
  );
}
